import React, { FC } from "react";
import {
  Box,
  createStyles,
  Grid as MaterialGrid ,
  makeStyles,
  Theme,
  Typography,
  withWidth,
} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import {
  EditingState,
  PagingState,
  RowDetailState,
  SortingState,
} from '@devexpress/dx-react-grid';
import {
  DragDropProvider,
  Grid as DevExpressGrid,
  Table,
  TableColumnVisibility,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import { ToolDisposalNoDataCell } from "./toolDisposalNoDataCell";
import { ToolDisposalSortLabel } from "./toolDisposalSortLabel";
import { ToolDisposalTableComponent } from "./toolDisposalTableComponent";
import { ToolDisposalCellComponent } from "./toolDisposalCellComponent";


export type TableColumnExtensions = {
  columnName: string;
  wordWrapEnabled: boolean;
  width?: number | string;
};
export type ColumnType = {
  name: string;
  title: string;
  wordWrapEnabled?: boolean;
  renderCell?: any
};
export const ToolDisposalRow: FC<{ row: any }> = ({ row }) => {
  const toolsDetails =
    row?.toolsDetails?.toolsDetail?.map((tool: any) => ({
      ...tool,
      modelYearMinMax: `${tool.modelYearMin ?? ""} - ${tool.modelYearMax ?? ""}`.trim() || "",
    })) ?? [];
  const classes = useStyles();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const columns: ColumnType[] = [
   
    { name: 'toolNumber', title: 'Tool Number', wordWrapEnabled: true },
    { name: 'toolDescription', title: 'Tool Description ', wordWrapEnabled: true },
    { name: 'supplierNumber', title: 'Supplier Number', wordWrapEnabled: true },
    { name: 'supplierName', title: 'Supplier Name', wordWrapEnabled: true },
    { name: 'productLines', title: 'Product Lines', wordWrapEnabled: true },
    { 
      name: 'modelYearMinMax', 
      title: 'Model Year (Min - Max)', 
      wordWrapEnabled: true, 
      renderCell: ({ row }) => row.modelYearMinMax
    },
   
  ];
  const tableColumnExtensions: TableColumnExtensions[] = [
    {
      columnName: "toolNumber",
      wordWrapEnabled: true,
    },
    {
      columnName: "supplierName",
      wordWrapEnabled: true,
    },
    {
      columnName: "productLines",
      wordWrapEnabled: true,
    },
    {
      columnName: "modelYearMinMax",
      wordWrapEnabled: true,
    },
  ];

  return (
    <MaterialGrid
      container
      direction={"row"}
      spacing={4}
      justifyContent={"center"}
      
    >
      <MaterialGrid style={{ margin: '0 auto'}} container spacing={isSmall ? 0 : 5}>
        <MaterialGrid item xs={12} lg={6}>
          <MaterialGrid container wrap="nowrap">
            <MaterialGrid item xs={6}>
              <Typography noWrap>
                <Box fontWeight="fontWeightBold" m={1}>
                  Summary - Reason for Request:
                </Box>
              </Typography>
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              <Typography noWrap>
                <Box fontWeight="fontWeightRegular" m={1}>
                  {row.reasonForRequest}
                </Box>
              </Typography>
            </MaterialGrid>
          </MaterialGrid>

        </MaterialGrid>
        <MaterialGrid item xs={12} lg={6}>
          <MaterialGrid container wrap="nowrap">
            <MaterialGrid item xs={6}>
              <Typography noWrap>
                <Box fontWeight="fontWeightBold" m={1}>
                  Business Unit::
                </Box>
              </Typography>
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              <Typography noWrap>
                <Box fontWeight="fontWeightRegular" m={1}>
                  {row.businessUnit}
                </Box>
              </Typography>
            </MaterialGrid>
          </MaterialGrid>

        </MaterialGrid>
        <Box sx={{ width:'95%',margin: '0 auto', marginBottom: '40px'}}>

          <DevExpressGrid 
          rows={Array.isArray(toolsDetails) ? toolsDetails : []} 
          columns={Array.isArray(columns) ? columns : []}
          >
              <EditingState onCommitChanges={() => console.log("clicked")} />

              <PagingState
                currentPage={1}
              />
            
              <DragDropProvider />
              <RowDetailState

              />
              <Table
                tableComponent={ToolDisposalTableComponent}
                columnExtensions={tableColumnExtensions}
                noDataCellComponent={ToolDisposalNoDataCell}
                cellComponent={ToolDisposalCellComponent}
              />
              <TableHeaderRow
                // BEGIN: Fix header row style issue
                cellComponent={(props) => (
                  <TableHeaderRow.Cell {...props} style={{ backgroundColor: '#B2B2B2', color: '#000'}} />
                )}
                // END: Fix header row style issue
              />
            </DevExpressGrid>
            </Box>
      </MaterialGrid>
    </MaterialGrid>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    autocompleteNoOptions: {
      color: theme.palette.text.primary,
    },
    [theme.breakpoints.up("sm")]: {
      backgroundColor: "red",
      padding: 100,
    },

    rowContainer: {
      padding: theme.spacing(0.5, 5),
      [theme.breakpoints.up("sm")]: {},
    },
  })
);
